const DEFAULT_RUNTIME_CONFIG = {
  APPLICATION_SETTING: {
    SMTP_HOST: '',
  },
  APPLICATION_SECURITY: {
    READ: 'read',
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
  },
  APPLICATION_FEATURE: {},
};

const CONFIG_FETCH_TIMEOUT_MS = 8000;

function withTimeout(promise, timeoutMs) {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error(`Timed out after ${timeoutMs}ms`)), timeoutMs);
    }),
  ]);
}

function preserveApiPaths(nextConfig, currentConfig) {
  return {
    ...nextConfig,
    APPLICATION_API: currentConfig.APPLICATION_API,
    APPLICATIONMANAGER_API: currentConfig.APPLICATIONMANAGER_API,
  };
}

export function applyRuntimeConfigDefaults() {
  const current = window.config || {};
  const next = {
    ...DEFAULT_RUNTIME_CONFIG,
    ...current,
    APPLICATION_SETTING: {
      ...DEFAULT_RUNTIME_CONFIG.APPLICATION_SETTING,
      ...(current.APPLICATION_SETTING || {}),
    },
    APPLICATION_SECURITY: {
      ...DEFAULT_RUNTIME_CONFIG.APPLICATION_SECURITY,
      ...(current.APPLICATION_SECURITY || {}),
    },
    APPLICATION_FEATURE: {
      ...DEFAULT_RUNTIME_CONFIG.APPLICATION_FEATURE,
      ...(current.APPLICATION_FEATURE || {}),
    },
    localizedStrings: {
      AppName: current.APPLICATION_NAME || 'iDeploy',
      ...(current.localizedStrings || {}),
    },
  };

  window.config = preserveApiPaths(next, current);
}

function mergeRuntimeConfigFromApi(configFromApi) {
  if (!configFromApi || typeof configFromApi !== 'object') return;
  const current = window.config || {};
  const merged = {
    ...current,
    APPLICATION_UUID: configFromApi.APPLICATION_UUID || current.APPLICATION_UUID,
    APPLICATION_NAME: configFromApi.APPLICATION_NAME || current.APPLICATION_NAME,
    APPLICATION_SETTING: {
      ...(current.APPLICATION_SETTING || {}),
      ...(configFromApi.APPLICATION_SETTING || {}),
    },
    APPLICATION_SECURITY: {
      ...(current.APPLICATION_SECURITY || {}),
      ...(configFromApi.APPLICATION_SECURITY || {}),
    },
    APPLICATION_FEATURE: {
      ...(current.APPLICATION_FEATURE || {}),
      ...(configFromApi.APPLICATION_FEATURE || {}),
    },
    localizedStrings: {
      ...(current.localizedStrings || {}),
      ...(configFromApi.localizedStrings || {}),
    },
  };
  window.config = preserveApiPaths(merged, current);
}

export async function hydrateRuntimeConfig() {
  applyRuntimeConfigDefaults();
  const { APPLICATIONMANAGER_API, APPLICATION_UUID } = window.config || {};
  if (!APPLICATIONMANAGER_API || !APPLICATION_UUID) return;

  try {
    const response = await withTimeout(
      fetch(`${APPLICATIONMANAGER_API}/config/${APPLICATION_UUID}`, {
        credentials: 'omit',
      }),
      CONFIG_FETCH_TIMEOUT_MS
    );
    if (!response.ok) return;

    const payload = await response.json();
    const configFromApi = payload?.config || payload?.data || payload || {};
    mergeRuntimeConfigFromApi(configFromApi);
  } catch (_error) {
    // Fail open in local mode; defaults are already applied.
  } finally {
    applyRuntimeConfigDefaults();
  }
}
